import { Heading, VStack } from '@chakra-ui/react';
import { MainTemplate } from '../templates/MainTemplate';
import { ContactForm } from '../components/forms/ContactForm';
import { Footer } from '../components/organisms/Footer';

export function ContactPage() {
  return (
    <MainTemplate hideBottomMenu>
      <VStack
        align={'flex-start'}
        width={'90%'}
        paddingTop={'20px'}
      >
        <Heading paddingBottom={'10px'}>Contato</Heading>
        <ContactForm />
        <Footer />
      </VStack>
    </MainTemplate>
  );
}
